import { Outlet } from "react-router-dom";

const ClientMinimalHeaderLayout = () => {
  return (
    <div className="min-h-screen bg-white">
      <header className="fixed top-0 z-992 w-full bg-black">
        <div className="mx-auto w-full px-5 py-4">
          <a href="/" title="Deloitte logo" className="inline-flex">
            <img
              src="/assets/img/deloitte_logo.svg"
              alt="Deloitte"
              className="max-h-4"
            />
          </a>
        </div>
      </header>

      <main className="pt-16">
        <div className="mx-auto w-full max-w-6xl px-4 py-3 md:py-5">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default ClientMinimalHeaderLayout;
